import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { Dashboard } from '~features/dashboard';

const dashboardSearchParamSchema = z.object({ id: z.string().optional() });

// const Component = () => {
//   const { data, isFetching } = useGetStudioDetails();

//   return (
//     <>
//       {isFetching ? (
//         <div className='flex h-screen items-center justify-center'>
//           <Loader2 className='size-6 animate-spin' />
//         </div>
//       ) : data?.newDashboard ? (
//         <Dashboard />
//       ) : (
//         <OldDashboard />
//       )}
//     </>
//   );
// };

export const Route = createFileRoute('/_auth/_layout/new-dashboard')({
  validateSearch: zodValidator(dashboardSearchParamSchema),
  component: Dashboard,
});
